import SignInForm from '@/components/auth/SignInForm'
import SignUpForm from '@/components/auth/SignUpForm'
import { AuthDialogType, closeAuthDialog, switchAuthDialog } from '@/store/slices/ui-state.slice'
import { RootState } from '@/store/store'
import { useAppDispatch, useAppSelector } from '@/store/store-hooks'
import AuthIncentive from './AuthIncentive'
import MobileFeaturedLogos from './MobileLogos'
import { useNavigate } from 'react-router-dom'
import SendPasswordResetForm from '@/components/auth/SendPasswordResetForm'

export default function DashboardAuth() {
  // Watch global UI state
  const { authDialogType } = useAppSelector((state: RootState) => state.uiState)

  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  return (
    <div className={'flex-grow flex flex-col overflow-y-auto items-center p-4 lg:min-h-screen'}>
      <div className={'flex grow justify-center items-center md:pr-5 xl:pr-20 2xl:pr-64'}>
        <div className={'hidden md:block md:pr-4'}>
          <AuthIncentive />
        </div>
        <div className="relative transform rounded-lg bg-brand-neutral-50 p-4 pt-2 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-md sm:p-6">
          {authDialogType === AuthDialogType.SIGN_IN && (
            <SignInForm
              tooltipMessage="This feature requires a free account."
              switchToSignUp={() => dispatch(switchAuthDialog(AuthDialogType.SIGN_UP))}
              switchToForgotPassword={() => {
                dispatch(switchAuthDialog(AuthDialogType.FORGOT_PASSWORD))
              }}
              onSuccess={() => {
                dispatch(closeAuthDialog())
                navigate('/dashboard')
              }}
            />
          )}
          {authDialogType === AuthDialogType.FORGOT_PASSWORD && <SendPasswordResetForm goToSignIn={() => dispatch(switchAuthDialog(AuthDialogType.SIGN_IN))} />}
          {authDialogType === AuthDialogType.SIGN_UP && (
            <SignUpForm
              tooltipMessage="This feature requires a free account."
              switchToSignIn={() => dispatch(switchAuthDialog(AuthDialogType.SIGN_IN))}
              onSuccess={() => {
                dispatch(closeAuthDialog())
                navigate('/dashboard')
              }}
              allowReferral={true}
            />
          )}
        </div>
      </div>
      <div className={'block md:hidden'}>
        <MobileFeaturedLogos />
      </div>
    </div>
  )
}
